export default __webpack_public_path__ + "static/flashcard_fist_to_five-e8671e8ebd88a0a0c2ff2d286025ea41.png";